import { AxiosPublic } from "../config/axios";

export async function getBanner(id) {
  return await AxiosPublic.get(`/baners/${id}`)
    .then(res => res.data.data)
    .catch(err => { alert(err.response?.data.message); return null })
}